"use client";

import { Input } from "@medusajs/ui";
import { SquareMinus, SquarePlus } from "lucide-react";
import { useEffect, useState } from "react";

interface CounterProps {
  defaultValue: number;
  onChange: (value: number) => void;
  error?: string;
}

const Counter = ({ defaultValue = 1, onChange, error }: CounterProps) => {
  const [value, setValue] = useState<number>(defaultValue);

  const handleIncrement = () => {
    const newValue = value + 1;
    setValue(newValue);
    onChange(newValue);
  };

  const handleDecrement = () => {
    if (value == 1) return null;
    const newValue = value > 0 ? value - 1 : 1;
    setValue(newValue);
    onChange(newValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value.replace(/\D/g, "");
    if (newValue === value.toString()) return;

    const parsedValue = newValue && parseInt(newValue, 10) > 0 ? parseInt(newValue, 10) : 1;

    setValue(parsedValue);
    onChange(parsedValue);
  };

  // Cập nhật giỏ hàng thành công

  useEffect(() => {
    const timeout = setTimeout(() => {
      setValue(value);
    }, 500);
    return () => clearTimeout(timeout);
  }, [value]);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className="flex items-center gap-1">
      <div className="cursor-pointer" onClick={handleDecrement}>
        <SquareMinus className="text-gray-500 hover:text-primary-700" size={30} strokeWidth={0.5} />
      </div>
      <Input
        value={value ?? 1}
        placeholder="1"
        onChange={handleChange}
        min={1}
        className={`w-12 p-0 pl-1 ${error ? "border-red-500" : ""}`}
      />
      <div className="cursor-pointer" onClick={handleIncrement}>
        <SquarePlus className="text-gray-500 hover:text-primary-700" size={30} strokeWidth={0.5} />
      </div>
    </div>
  );
};

export default Counter;
